import { computed } from 'vue';
import { useStore } from 'vuex';

export default function useEnvProps() {
  const store = useStore();
  const envProps = computed(() => store?.state?.envProps || {});

  // ENV PROP(s)
  const entryPoint = computed(() => envProps.value?.entryPoint || envProps.value?.brand || '');

  return {
    entryPoint,
  };
}
